<template>
  <tr class="pt-message-table-item">
       <td ref="td"  :style="{width:tdMaxWidth?(tdMaxWidth+'px'):'auto'}">{{label}}：</td>
       <td><slot/></td>
  </tr>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-message-table-item'

export default {
  name: 'pt-message-table-item',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    tdMaxWidth: {
      type: [Number, String],
      default: 0
    },
    needRequest: {
      type: Boolean,
      default: false
    },
    isRequested: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      width_item: null
    }
  },
  watch: {
    width_item: {
      // 1、子模块样式。所有子模块的label右对齐
      // a、每个子模块中，随意挑选一个pt-form-list-item（因为同一个子模块，label的宽度是相等的）,调用widthItem方法，在此方法中，将每一次获取的宽度push进一个数组。
      // b、取出数组中的最大值，在每个子模块中，随意挑选一个pt-form-list-item，将最大值（widthMax）传入
      handler: function (val) {
        this.$emit('widthItem', val)
      },
      immediate: true
    },
    isRequested (val) {
      if (this.needRequest && val) {
        this.$nextTick(_ => {
          this.width_item = this.$refs.td && this.$refs.td.getBoundingClientRect().width
        })
      }
    }
  },
  created () {
    this.$nextTick(_ => {
      // 获取第一个td即label部分的宽度
      this.width_item = this.$refs.td && this.$refs.td.getBoundingClientRect().width
    })
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import "~less/var";
.pt-message-table-item{
      >td{
            line-height: 30px;
            font-size: 14px;
        }
        >:first-child{
            display: flex;
            color:@mainColor;
            justify-content: flex-end;
            white-space:nowrap
        }
        >:last-child{
            color: #585558
        }
}
</style>
